import { render, staticRenderFns } from "./V2SpFormCardLayout.vue?vue&type=template&id=a1ff2c7e&"
import script from "./V2SpFormCardLayout.vue?vue&type=script&lang=ts&"
export * from "./V2SpFormCardLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports